export default {
  GET_ERROR: {
    title: 'There was an issue fetching vitals.'
  },
  UPDATE_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'There was an issue updating your vitals.'
  },
  VITALS_ERROR_MESSAGE: {
    WEIGHT: {
      MAJOR: 'The value for Weight must be between 0 and 1500 lbs.',
      MINOR: 'The value for Weight must be between 0 and 15 oz.'
    },
    HEIGHT: {
      MAJOR: 'The value for Height must be between 0 and 10 ft.',
      MINOR: 'The value for Height must be between 0 and 11 in.'
    },
    TEMPERATURE: 'The value for Temperature must be between 0 and 120 degrees. Fahrenheit.',
    SYSTOLIC: 'The value for Systolic Blood Pressure must be between 0 and 250.',
    DIASTOLIC: 'The value for Diastolic Blood Pressure must be between 0 and 250.',
    NO_SPECIAL_CHARS: 'Please use integers only (no special characters).',
    NO_DECIMALS_OR_SPECIAL_CHARS: 'Please use integers only (no decimals or special characters).'
  }
};
